export default __webpack_public_path__ + "static/media/resume_work.18565077.pdf";